import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskScheduleCanceled_ActivityLogFragment, BoolOrgPref } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import { useOrgPrefBoolTyped } from 'src/hooks/api/org';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskScheduleCanceled_ActivityLogFragment;
}

const ActivityLogTaskScheduleCanceled: FCWithFragments<Fragments> = ({ activityLog }) => {
  const [candidatePulseOrgPref] = useOrgPrefBoolTyped(BoolOrgPref.BoolShouldSendCandidatePulse);
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabel={
        candidatePulseOrgPref === true
          ? 'canceled the schedule. The pulse survey for the schedule was also removed'
          : 'canceled the schedule'
      }
      actionLabelKey={
        candidatePulseOrgPref === true
          ? 'hiring-dashboard-candidates:candidates.activityLog.canceledScheduleWithSurvey'
          : 'hiring-dashboard-candidates:candidates.activityLog.canceledSchedule'
      }
    />
  );
};

ActivityLogTaskScheduleCanceled.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskScheduleCanceled_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskScheduleCanceled;
